import React, { useState, useRef, useEffect, useContext } from "react";
import { Row, Col, message, Button, Image, Carousel } from "antd";
import ICDong from './../acsset/ic-dong.png';
import IMGAdd from './../acsset/image-add.png';
import ICCamera from './../acsset/ic-camera.svg';
import ViewImage from './modal/viewImage';
import CameraInput from './camera'
import { AuthContext } from "./index";

const Capture = (props) => {
  const { isMobile, dataCheckupload, imageKeys, compressIMG, ActionList, uploadG2 } = useContext(AuthContext);
  const status = +dataCheckupload?.status;
  const [idxEdit, setIdxEdit] = useState(null);
  const [multiplePhotos, setMultiplePhotos] = useState(false);
  const importInputRef = useRef();

  useEffect(() => {

  }, []);

  return (
    <>
      <CameraInput ref={importInputRef} idxEdit={idxEdit} multiplePhotos={multiplePhotos} />
      <Row style={{ maxWidth: 834, margin: '0px auto' }} gutter={isMobile ? [10, 16] : [15, 15]}>
        <Col xs={24} md={24}>
          {
            status === 4 &&
            <div style={{ padding: 10, borderRadius: 16, display: 'grid', gap: 10, background: '#fff', marginBottom: 15, fontSize: 14, fontWeight: 500 }}>
              {
                "Lý do: "+dataCheckupload?.config?.rejectionReason
              }
              <div style={{ height: '0.5px', width: '100%', background: '#D2D2D2' }}></div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                  <div style={{ width: 10, height: 10, background: '#0B7CE4', borderRadius: '50%' }}></div>
                  <b style={{ color: '#0B7CE4', fontSize: 14 }}>Bổ sung hình ảnh</b>
                </div>
                <div style={{ color: '#646D69', fontSize: 12 }}>
                  {dataCheckupload?.config?.rejectionTime}
                </div>
              </div>
            </div>
          }
          <div style={{ display: 'grid', gap: 5 }}>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#FB7800' }}>Điểm đặc biệt lưu ý:</div>
            <div style={{ display: 'flex', gap: 5, color: '#343A40' }}>
              1.
              <div style={{ textAlign: 'justify' }}>
                Hình thể hiện ngày tháng chụp: Tải app thể hiện ngày chụp lên hình, lấy tờ lịch ngày hiện tại, hoặc viết ngày chụp lên giấy chụp cùng 5 hình tổng quan trước, sau, trái, phải & số khung xe
              </div>
            </div>
            <div style={{ display: 'flex', gap: 5, color: '#343A40' }}>
              2.
              <div style={{ textAlign: 'justify' }}>
                Phải có số khung xe
              </div>
            </div>
            <div style={{ display: 'flex', gap: 5, color: '#343A40' }}>
              3.
              <div style={{ textAlign: 'justify' }}>
                Nổ máy xe 30 giây để các đồng hồ báo lỗi kịp tắt hết rồi chụp hình đồng hồ táp lô (thể hiện được số km tổng)
              </div>
            </div>
            <div>
              Thiếu 1 trong 3 thông tin trên Claims không xem xét duyệt được.
            </div>
          </div>
        </Col>
        {
          (imageKeys || []).map((data, index) => (
            <Col key={data.code} xs={12} md={8}>
              <div style={{ background: '#fff', borderRadius: 16, padding: 10, height: '100%', display: 'flex', flexDirection: 'column', justifyContent:'space-between'}}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                  <div>
                    <b style={{ fontSize: isMobile ? 12 : 15 }}>{data.title}</b>
                    {
                      data?.required &&
                      <sup style={{ color: 'red' }}>*</sup>
                    }
                  </div>
                  {
                    (data?.multiplePhotos && data?.urlLocal?.length > 0) &&
                    <img
                      onClick={() => {
                        setIdxEdit(index);
                        setTimeout(() => {
                          importInputRef.current.click();
                        }, 100);
                      }}
                      src={IMGAdd} width={'18px'} style={{ cursor: 'pointer' }}
                    />
                  }
                </div>
                <div style={{ color: '#646D69', textAlign: 'justify', fontSize: isMobile ? 10 : 14, marginTop: 5, flex: 1 }}>
                  {data?.description}
                </div>
                {
                  !data?.urlLocal?.length &&
                  <div style={{ borderRadius: 12, padding: 5, background: '#F0F2F5', border: '1px dashed #D2D2D2', gap: 10, display: 'grid', textAlign: 'center', alignItems: 'flex-end', marginTop: 10, aspectRatio: '1 / 1' }}>
                    <img src={data?.imgDefault} width={'100%'} />
                    <div onClick={() => {
                      setMultiplePhotos(data?.multiplePhotos);
                      setIdxEdit(index);
                      setTimeout(() => {
                        importInputRef.current.click();
                      }, 100);
                    }} style={{ padding: '8px 12px', background: '#fff', borderRadius: 8, width: '100%', border: '0.5px solid #D2D2D2', margin: '0px auto', fontWeight: 500, display: 'flex', gap: isMobile ? 5 : 10, alignItems: 'center', cursor: 'pointer', justifyContent: 'center' }}>
                      <img src={ICCamera} width={'18px'} /> Chụp ảnh lên
                    </div>
                  </div>
                }
                {
                  data?.urlLocal?.length > 0 &&
                  <div style={{ borderRadius: 12, padding: 5, background: '#F0F2F5', border: '1px dashed #D2D2D2', alignItems: 'center', marginTop: 10, height: '100%', flex: 1 }}>
                    <ViewImage code={data?.code} listImage={data?.urlLocal} isMobile={isMobile} ActionList={ActionList} />
                  </div>
                }
              </div>
            </Col>
          ))
        }
      </Row>
    </>

  );
};
export default Capture;
